import React, {useEffect, useState} from "react";

import { graphql } from "gatsby";

import { useTranslation, useI18next } from 'gatsby-plugin-react-i18next';

import api from "../../utils/api";
import {readPdfQuery} from "../../utils/notificationLinks";
import {normalizePdfUri} from "../../utils/pdf";

import {useCookies} from "react-cookie";

import Layout from "../../components/Layout";
import Section from "../../components/Section";
import Promo from "../../components/Promo";
import Card from "../../components/Card";
import PdfViewer from "../../components/PdfViewer";
import PrivateRoute from "../../components/PrivateRoute";
import {GuideVideos} from "../../components/Guide/Sections/guide-videos";

function Guide(props) {
	const { t } = useTranslation();
	const { language } = useI18next();

	const search =
		(props.location && props.location.search) ||
		(typeof window !== "undefined" ? window.location.search : "");
	const query = readPdfQuery(search);

	const [guides, setGuides] = useState([]);
	const [pdf, setPdf] = useState(query.pdf);
	const [pdfTitle, setPdfTitle] = useState(
		query.text || t("Dr Simeonsi dieediprogrammi juhend")
	);
	const [cookies] = useCookies(["token", "id"]);
	const [token] = useState(cookies["token"]);
	const [idUser] = useState(cookies["id"]);

	useEffect(() => {
		if (!token || !idUser) {
			return;
		}
		api.getUserGuides(token, {id: idUser}, language)
			.then((res) => {
				setGuides(res.files || []);
			})
			.catch(() => {
				setGuides([]);
			});
	}, [idUser, token, language]);

	useEffect(() => {
		const next = readPdfQuery(
			(props.location && props.location.search) ||
				(typeof window !== "undefined" ? window.location.search : "")
		);
		if (next.pdf) {
			setPdf(next.pdf);
			if (next.text) {
				setPdfTitle(next.text);
			}
		}
	}, [props.location && props.location.search]);

	function setCurrentPdf(link, title) {
		setPdf(normalizePdfUri(link) || link);
		setPdfTitle(title);
	}

	function handleBackClick() {
		setPdf(null);
		setPdfTitle(t("Dr Simeonsi dieediprogrammi juhend"));
		if (typeof window !== "undefined" && props.location && props.location.pathname) {
			window.history.replaceState({}, "", props.location.pathname);
		}
	}

	return (
		<Layout location={props.location}>
			<Section title={pdfTitle}>
				{pdf === null ? (
					<ul className={"mt-11 md:w-11/12"}>
						{guides.map((item) => {
							return (
								<Card
									guidePage={true}
									key={item.displayName}
									setCurrentPdf={setCurrentPdf}
									title={item.displayName}
									link={item.filePath}
								/>
							);
						})}
					</ul>
				) : (
					<PdfViewer
						fileUrl={pdf}
						onBack={handleBackClick}
						backLabel={t("back", {defaultValue: "Back"})}
						zoomInLabel={t("zoom_in", {defaultValue: "Zoom in"})}
						zoomOutLabel={t("zoom_out", {defaultValue: "Zoom out"})}
					/>
				)}
			</Section>

			{pdf === null ? <GuideVideos/> : null}

			<Promo/>
		</Layout>
	);
}

export default function GuidePage(props) {
	return <PrivateRoute component={Guide} location={props.location} />;
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: {language: {eq: $language}}) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
